<template>
  <div class="order-detail-page">
    <!-- 页面顶部背景色 -->
    <div class="page-top-bg"></div>
    
    <!-- 页面顶部渐变背景 -->
    <div class="page-gradient-bg"></div>

    <!-- 步骤指示器 -->
    <div class="navbar">
      <img :src="navbarImg" alt="步骤指示器" class="navbar-img" />
    </div>

    <!-- 设备SN卡片 -->
    <div class="card-container">
      <!-- 卡片顶部渐变色装饰条(绝对定位,不占空间) -->
      <div class="card-gradient-bar"></div>
      
      <!-- 内容区域 -->
      <div class="content">
        <!-- 设备SN标题 -->
        <div class="section-header">
          <div class="title-decoration">
            <span class="orange-line"></span>
            <span class="section-title">设备SN</span>
          </div>
        </div>

        <!-- SN输入框 -->
        <div class="input-wrapper">
          <input
            v-model="snCode"
            type="text"
            placeholder="请输入设备SN"
            class="sn-input"
          />
          <img
            :src="scanIcon"
            alt="扫描"
            class="scan-icon"
            @click="handleScan"
          />
        </div>

        <!-- 重新查询按钮 -->
        <div class="query-btn" @click="handleReQuery">
          重新查询
        </div>
      </div>
    </div>

    <!-- 交易信息卡片 -->
    <div class="card-container transaction-card">
      <!-- 内容区域 -->
      <div class="content">
        <!-- 交易信息标题 -->
        <div class="section-header">
          <div class="title-decoration">
            <span class="orange-line"></span>
            <span class="section-title">交易信息</span>
          </div>
        </div>

        <!-- 交易信息列表 -->
        <div class="info-list">
          <div class="info-item">
            <span class="info-label">设备SN:</span>
            <span class="info-value">{{ orderData.snCode || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">交易卡号:</span>
            <span class="info-value">{{ maskCardNo(orderData.cardNo) }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">交易金额:</span>
            <span class="info-value amount">¥{{ formatAmount(orderData.transAmount) }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">风险冻结费:</span>
            <span class="info-value amount highlight">¥{{ formatAmount(orderData.customAddRateRealAmount) }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">交易订单号:</span>
            <span class="info-value">{{ orderData.orderId || '-' }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">交易时间:</span>
            <span class="info-value">{{ orderData.transTime || '-' }}</span>
          </div>
        </div>

        <!-- 操作按钮区域 -->
        <div class="action-buttons" v-if="hasOrderData">
          <!-- 申请解冻按钮 -->
          <div 
            v-if="!hasApplied" 
            class="apply-btn" 
            @click="openApplyModal"
          >
            申请解冻
          </div>
          <!-- 已申请解冻按钮(禁用状态) -->
          <div 
            v-else 
            class="applied-btn disabled"
          >
            已申请解冻
          </div>
        </div>
      </div>
    </div>

    <!-- 申请解冻弹窗 -->
    <van-popup
      v-model="showModal"
      round
      position="bottom"
      :style="{ height: '275px' }"
      closeable
    >
      <div class="modal-content">
        <div class="modal-header">
          <span class="modal-title">申请解冻</span>
        </div>
        
        <div class="modal-body">
          <div class="input-wrapper modal-input">
            <input
              v-model="refundAmount"
              type="number"
              step="0.01"
              placeholder="请输入解冻金额"
              class="amount-input"
            />
          </div>
          
          <p class="modal-description">说明:解冻成功后将退回至结算账户</p>
          
          <div class="modal-btn" @click="handleApply">
            申请解冻
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import { getAuthInfo, queryOrder, applyRefund } from "@/api/common";

export default {
  name: "OrderDetail",
  data() {
    return {
      snCode: "",
      loading: false, // 加载状态
      showModal: false, // 弹窗显示状态
      refundAmount: "", // 解冻金额
      hasApplied: false, // 是否已申请解冻
      navbarImg: require("../../assets/order/navbar2.png"),
      scanIcon: require("../../assets/order/scan-icon.png"),
      orderData: {
        snCode: "",
        cardNo: "",
        transAmount: "",
        customAddRateRealAmount: "",
        orderId: "",
        transTime: "",
        merId: "",
      },
    };
  },
  computed: {
    // 判断是否有订单数据
    hasOrderData() {
      return this.orderData && this.orderData.snCode;
    }
  },
  created() {
    // 从路由参数获取数据
    const query = this.$route.query;
    if (query) {
      this.snCode = query.snCode || "";
      this.orderData = {
        snCode: query.snCode || "",
        cardNo: query.cardNo || "",
        transAmount: query.transAmount || "",
        customAddRateRealAmount: query.customAddRateRealAmount || "",
        orderId: query.orderId || "",
        transTime: query.transTime || "",
        merId: query.merId || "",
      };
    }
  },
  methods: {
    // 点击扫描图标
    async handleScan() {
      // 防止重复点击
      if (this.loading) {
        return;
      }
      
      try {
        // 显示加载中
        this.loading = true;
        const loadingToast = this.$toast.loading({
          message: "授权中...",
          forbidClick: true,
          duration: 0,
        });
        
        // 调用微信JSSDK授权接口
        const res = await getAuthInfo({ urlType: 1 });
        console.log("授权信息:", res);
        
        // 关闭loading toast
        loadingToast.clear();
        
        // 配置微信JSSDK
        wx.config({
          debug: false,
          appId: res.appId,
          timestamp: res.timestamp,
          nonceStr: res.nonceStr,
          signature: res.signature,
          jsApiList: ["scanQRCode"],
        });

        // 等待配置完成后执行扫码
        wx.ready(() => {
          console.log("微信JSSDK配置成功，开始扫码");
          wx.scanQRCode({
            needResult: 1,
            scanType: ["barCode"],
            success: (result) => {
              console.log("扫码成功:", result);
              // 扫码结果填充到输入框
              let barCode = result.resultStr.split(",");
              this.snCode = barCode[barCode.length - 1];
            },
            fail: (err) => {
              console.error("扫码失败:", err);
              this.$toast.fail("扫码失败，请重试");
            },
          });
        });

        wx.error((err) => {
          console.error("微信授权失败:", err);
          this.$toast.fail("微信授权失败，请检查网络后重试");
        });
      } catch (error) {
        console.error("获取授权信息失败:", error);
        this.$toast.fail(error.message || "获取授权信息失败");
      } finally {
        // 关闭加载状态
        this.loading = false;
      }
    },

    // 重新查询按钮
    async handleReQuery() {
      // 防止重复点击
      if (this.loading) {
        return;
      }
      
      // 验证是否输入设备SN
      if (!this.snCode || this.snCode.trim() === "") {
        this.$toast("请输入设备SN");
        return;
      }

      try {
        // 显示加载中
        this.loading = true;
        const loadingToast = this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0,
        });
        
        // 调用查询接口
        const res = await queryOrder({ sn: this.snCode.trim() });
        
        console.log("重新查询订单响应:", res);
        
        // 判断是否查询到订单信息
        if (!res) {
          // 关闭loading toast
          loadingToast.clear();
          // 未查询到订单信息，清空数据并隐藏按钮
          this.orderData = {
            snCode: "",
            cardNo: "",
            transAmount: "",
            customAddRateRealAmount: "",
            orderId: "",
            transTime: "",
            merId: "",
          };
          this.hasApplied = false;
          this.$toast("未查询到订单");
          return;
        }
        
        // 更新订单数据
        this.orderData = {
          snCode: res.snCode || "",
          cardNo: res.cardNo || "",
          transAmount: res.transAmount || "",
          customAddRateRealAmount: res.customAddRateRealAmount || "",
          orderId: res.orderId || "",
          transTime: res.transTime || "",
          merId: res.merId || "",
        };
        
        // 重置申请状态，按钮变回“申请解冻”
        this.hasApplied = false;
        
        // 查询成功，关闭loading toast
        loadingToast.clear();
        this.$toast("查询成功");
      } catch (error) {
        // 错误已全局处理，这里可以添加额外的错误处理逻辑
        console.error("重新查询订单失败:", error);
        this.$toast.fail(error.message);
      } finally {
        // 关闭加载状态
        this.loading = false;
      }
    },

    // 打开申请解冻弹窗
    openApplyModal() {
      this.refundAmount = "";
      this.showModal = true;
    },

    // 关闭弹窗
    closeModal() {
      this.showModal = false;
      this.refundAmount = "";
    },

    // 申请解冻
    async handleApply() {
      // 验证解冻金额
      if (!this.refundAmount || this.refundAmount.trim() === "") {
        this.$toast("请输入解冻金额");
        return;
      }

      const amount = parseFloat(this.refundAmount);
      
      // 验证金额格式
      if (isNaN(amount)) {
        this.$toast("请输入有效的金额");
        return;
      }

      // 验证金额大于0
      if (amount <= 0) {
        this.$toast("解冻金额必须大于0");
        return;
      }

      // 验证金额不超过风险冻结费
      const maxAmount = parseFloat(this.orderData.customAddRateRealAmount);
      if (amount > maxAmount) {
        this.$toast(`解冻金额不能超过¥${this.formatAmount(maxAmount)}`);
        return;
      }

      // 验证保留两位小数
      const regex = /^\d+(\.\d{1,2})?$/;
      if (!regex.test(this.refundAmount)) {
        this.$toast("金额最多保留两位小数");
        return;
      }

      try {
        // 显示加载中
        const loadingToast = this.$toast.loading({
          message: "申请中...",
          forbidClick: true,
          duration: 0,
        });
        
        // 调用申请解冻接口
        const params = {
          dmCode: this.orderData.merId,
          refundAmount: this.refundAmount,
          refundRemark: "代理商户申请",
          transOrderId: this.orderData.orderId,
        };
        
        const res = await applyRefund(params);
        
        console.log("申请解冻响应:", res);
        
        // 关闭loading toast
        loadingToast.clear();
        
        // 判断是否成功
        if (res) {
          // 申请成功
          this.$toast("申请成功");
          this.closeModal();
          this.hasApplied = true;
        } else {
          // 申请失败
          this.$toast(res.message || "申请失败，请重试");
        }
      } catch (error) {
        // 错误已全局处理
        console.error("申请解冻失败:", error);
        this.$toast.fail(error.message);
      }
    },

    // 卡号脱敏处理
    maskCardNo(cardNo) {
      if (!cardNo) return "-";
      const str = String(cardNo);
      if (str.length <= 8) return str;
      const start = str.substring(0, 4);
      const end = str.substring(str.length - 4);
      return `${start}****${end}`;
    },

    // 格式化金额
    formatAmount(amount) {
      if (!amount && amount !== 0) return "0.00";
      const num = parseFloat(amount);
      if (isNaN(num)) return "0.00";
      return num.toFixed(2);
    },
  },
};
</script>

<style scoped lang="less">
.order-detail-page {
  min-height: 100vh;
  background-color: #f5f6fa;
  padding-bottom: 40px;
}

// 页面顶部背景色
.page-top-bg {
  width: 100%;
  height: 222px;
  background-color: #fff5e2;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

// 页面顶部渐变背景
.page-gradient-bg {
  width: 100%;
  height: 150px;
  background: linear-gradient(180deg, #fff5e2 0%, rgba(255, 245, 226, 0) 100%);
  position: absolute;
  top: 222px;
  left: 0;
  z-index: 0;
}

// 步骤指示器
.navbar {
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 54px;
  padding-bottom: 0;
  position: relative;
  z-index: 1;
  
  .navbar-img {
    width: 486px;
    height: 114px;
  }
}

// 卡片顶部渐变色装饰条
.card-gradient-bar {
  width: 100%;
  height: 116px;
  background: linear-gradient(180deg, rgba(254, 216, 157, 0.2) 0%, rgba(254, 216, 157, 0) 100%);
  border-radius: 22px 22px 0px 0px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
}

// 卡片容器
.card-container {
  width: 686px;
  margin: 54px auto 0;
  background: #fff;
  border-radius: 24px 24px 24px 24px;
  padding: 40px 22px;
  box-sizing: border-box;
  position: relative;
  
  // 交易信息卡片距离设备SN卡片24px
  &.transaction-card {
    margin-top: 24px;
  }
}

// 内容区域
.content {
  .section-header {
    margin-bottom: 30px;
    
    &.transaction-section {
      margin-top: 40px;
    }
    
    .title-decoration {
      display: flex;
      align-items: center;
      
      .orange-line {
        width: 8px;
        height: 30px;
        border-radius: 4px;
        background-color: #865d14;
        margin-right: 12px;
      }
      
      .section-title {
        font-size: 36px;
        font-weight: 700;
        color: #3d3d3d;
      }
    }
  }
  
  // 输入框
  .input-wrapper {
    position: relative;
    width: 642px;
    height: 96px;
    margin: 0 auto 48px;
    background: #f5f6fa;
    border-radius: 16px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    box-sizing: border-box;
    
    .sn-input {
      flex: 1;
      height: 100%;
      border: none;
      outline: none;
      background: transparent;
      font-size: 28px;
      color: #333;
      
      &::placeholder {
        color: #999;
        font-size: 28px;
      }
    }
    
    .scan-icon {
      width: 40px;
      height: 40px;
      cursor: pointer;
      margin-left: 16px;
    }
  }
  
  // 重新查询按钮
  .query-btn {
    width: 642px;
    height: 96px;
    margin: 0 auto;
    background-color: #fed89d;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 30px;
    color: #865d14;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 0.3s;
    
    &:active {
      opacity: 0.8;
    }
  }

  // 交易信息列表
  .info-list {
    width: 642px;
    margin: 0 auto 40px;
    
    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;
      
      .info-label {
        font-size: 28px;
        color: #666;
      }
      
      .info-value {
        font-size: 28px;
        color: #333;
        font-weight: 500;
      }
    }
  }
  
  // 操作按钮区域(在卡片内部)
  .action-buttons {
    width: 642px;
    margin: 0 auto;
    
    .apply-btn {
      width: 100%;
      height: 96px;
      background-color: #fed89d;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      color: #865d14;
      font-weight: 700;
      cursor: pointer;
      transition: opacity 0.3s;
      
      &:active {
        opacity: 0.8;
      }
    }
    
    .applied-btn {
      width: 100%;
      height: 96px;
      background-color: #e0e0e0;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      color: #999;
      font-weight: 700;
      cursor: not-allowed;
      
      &.disabled {
        opacity: 0.6;
      }
    }
  }
}

// 弹窗样式
.modal-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .modal-header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 30px 20px;
    position: relative;
    
    .modal-title {
      font-size: 32px;
      font-weight: 700;
      color: #333;
    }
  }
  
  .modal-body {
    flex: 1;
    padding: 30px;
    display: flex;
    flex-direction: column;
    
    .modal-input {
      width: 100%;
      height: 96px;
      background: #f5f6fa;
      border-radius: 16px;
      display: flex;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
      margin-bottom: 20px;
      
      .amount-input {
        flex: 1;
        height: 100%;
        border: none;
        outline: none;
        background: transparent;
        font-size: 28px;
        color: #333;
        
        &::placeholder {
          color: #999;
          font-size: 28px;
        }
      }
    }
    
    .modal-description {
      font-size: 24px;
      color: #999;
      margin: 0 0 64px;
      line-height: 1.5;
    }
    
    .modal-btn {
      width: 100%;
      height: 96px;
      background-color: #fed89d;
      border-radius: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 30px;
      color: #865d14;
      font-weight: 700;
      cursor: pointer;
      transition: opacity 0.3s;
      
      &:active {
        opacity: 0.8;
      }
    }
  }
}
</style>
